<script lang="ts">
    import { DEFAULT_BOX, DEFAULT_LAYOUT } from '$lib/components/constants';
    import { TRANSITION_DELAY } from '$lib/global/constants';

    import Transition from '$lib/components/Blocks/_wrappers/Transition.svelte';
    import { cn } from '$lib/utils/cn';

    import Answer from './Answer.svelte';
    import { getBoxAttributes } from '../_utils/getBoxAttributes';
    import Box from '../_wrappers/Box.svelte';
    import Text from '../Text/Text.View.svelte';

    import type { Box as BoxType, Align } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { JSONContent } from '@tiptap/core';
    import type { ComponentProps } from 'svelte';

    export let id = '';
    export let align: Align = 'center';
    export let draft: JSONContent;
    export let color = 'black';
    export let box: BoxType;
    export let onAnswerClick: ComponentProps<Answer>['onClick'];
    export let onAnswerMouseEnter: ComponentProps<Answer>['onMouseEnter'];
    export let answers: Omit<ComponentProps<Answer>, 'onClick' | 'onMouseEnter'>[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;

    const { isInColumn, isInMultiColumn } = layout;

    const isEven = answers.length % 2 === 0;

    let answersClasses = cn('answer fun-mt-6 fun-grid fun-grid-cols-1 fun-gap-4 md:fun-mt-10', {
        'md:fun-grid-cols-2': answers.length % 2 === 0,
    });

    if (isInMultiColumn) {
        answersClasses =
            'answer fun-mt-6 fun-grid fun-grid-cols-1 fun-gap-4 fun-max-w-md fun-mx-auto md:fun-mt-10';
    }
</script>

<Box
    {id}
    {...getBoxAttributes({ box, isInColumn })}
    {transitionDelay}
    {transitionEffect}
    narrow={!isEven}
>
    <Text raw={draft} {align} {color} box={DEFAULT_BOX} {layout} transitionEffect="none" />
    <div class={answersClasses}>
        {#each answers as answer, index (answer.id)}
            <Transition
                effect={transitionEffect}
                delay={transitionDelay + index * TRANSITION_DELAY}
            >
                <Answer {...answer} onClick={onAnswerClick} onMouseEnter={onAnswerMouseEnter} />
            </Transition>
        {/each}
    </div>
</Box>

<style lang="scss">
    .answer :global(h1),
    .answer :global(h2),
    .answer :global(h3),
    .answer :global(h4),
    .answer :global(p) {
        padding: 0 !important;
    }
</style>
